import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import moment from 'moment';
import { MonthView, TransitionView, Footer } from 'react-date-picker';

import 'react-date-picker/index.css';

class ClientNewTask extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectingDate: false,
      dueDateSelected: false,
      task: '',
      dueDate: '',
      clientId: this.props.clientId || null,
      selectingAssignment: false,
      assignedTo: '',
    };

    this.showAssignmentSelector = this.showAssignmentSelector.bind(this);
    this.onSelectAssignment = this.onSelectAssignment.bind(this);
    this.showDateSelector = this.showDateSelector.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    if (!this.props.client._id) {
      this.props.fetchClient(this.props.clientId);
    }

    this.props.getUserChildren();
  }

  onDateChange(date) {
    this.setState({
      dueDate: date,
      dueDateSelected: true,
      selectingDate: false
    });
  }

  showDateSelector() {
    this.setState({ selectingDate: !this.state.selectingDate, selectingAssignment: false });
  }

  showAssignmentSelector() {
    this.setState({ selectingAssignment: !this.state.selectingAssignment, selectingDate: false });
  }

  updateTask(e) {
    this.setState({
      task: e.target.value
    });
  }

  onSelectAssignment(e) {
    this.setState({ assignedTo: e.target.value || this.props.creator._id });
  }

  onSubmit(e) {
    if (e.key !== 'Enter' && e.key !== undefined) return;
    if (!this.state.task || !this.state.clientId) {
      return console.log('You must provide a clientId and valid task details.');
    }

    const task = {
      text: this.state.task,
      completed: false,
      assigned_to: this.state.assignedTo,
      client: this.state.clientId,
      due_date: this.state.dueDate
    }

    // Send websocket request to create a new task and broadcast to connected users.
    this.props.sendSocketEmit(task, 'client-task-new');

    this.setState({
      selectingDate: false,
      dueDateSelected: false,
      task: '',
      dueDate: '',
      clientId: this.props.clientId || null,
      selectingAssignment: false,
      assignedTo: null,
    });
  }

  render() {
    const formattedDueDate = this.state.dueDate ? moment(this.state.dueDate).format('YYYY.MM.DD') : '';
    return (
      <div className="client-new-task" ref="newTask">
        <div className="input-group input-group-lg mb-md">
          <span onClick={ this.showAssignmentSelector } title="Assign task" className="input-group-addon btn-primary">
            <i className="fa fa-user"></i>
          </span>
          <span onClick={ this.showDateSelector } title="Set due date" className="input-group-addon btn-primary">
            {(() => {
              const hasDueDate = moment(this.state.dueDate).isValid();

              return (hasDueDate ? `Due Date: ${formattedDueDate}` : <i className="fa fa-calendar"></i>);
            })()}
          </span>
          <input type="text" value={ this.state.task } onSubmit={ this.onSubmit } onKeyPress={ this.onSubmit } onChange={ this.updateTask } className="form-control input-lg" placeholder="Add a task..."/>

          <span title="Save" className="input-group-addon btn-primary" onClick={ this.onSubmit }>Submit</span>

          <div className="task-assignment" style={{ display: this.state.selectingAssignment ? '' : 'none' }}>
            <span> Assign this task to the following user : &nbsp; </span>
            <select className="input-sm" onChange={ this.onSelectAssignment } value={ this.state.assignedTo }>
              <option value="" defaultValue="">-- SELECT USER --</option>
              {
                this.props.users.children.map((child_user, idx) => {
                  child_user = child_user.user;
                  return (
                    <option key={idx} value={child_user._id}>{`${child_user.name.first} ${child_user.name.last}`}</option>
                  );
                })
              }
            </select>
          </div>

          <div className="due-date" style={{ display: this.state.selectingDate ? '' : 'none' }}>
            <MonthView footer weekNumbers={false} onChange={ this.onDateChange }/>
          </div>
        </div>
      </div>
    );
  }
}

ClientNewTask.propTypes = {
  client: PropTypes.object,
  users: PropTypes.object,
  clientId: PropTypes.string.isRequired
}

const mapStateToProps = ({ client, users }) => ({ client, users });


export default connect(mapStateToProps, Actions)(ClientNewTask);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-new-task.js